import {useImperativeHandle,useRef,type ComponentPropsWithRef} from 'react';
import {DevicePhonePicker} from './DevicePhonePicker.js';

/** A device-picked number follows the same input event path as manual typing. */
export function PhoneInput({ref,className,inline=false,...props}:ComponentPropsWithRef<'input'>&{inline?:boolean}) {
  const input=useRef<HTMLInputElement>(null);
  useImperativeHandle(ref,()=>input.current!,[]);
  const pick=(phone:string)=>{
    const element=input.current;
    if(!element||element.disabled||element.readOnly)return;
    const setter=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value')?.set;
    setter?.call(element,phone);
    element.dispatchEvent(new Event('input',{bubbles:true}));
  };
  return <span className={`relative inline-block min-w-0 max-w-full align-middle${inline?'':' w-full'}`}>
    <input {...props} ref={input} className={`${className??''} pe-11`}/>
    {!props.disabled&&!props.readOnly&&<DevicePhonePicker onPick={pick}/>}
  </span>;
}
